import React, { useState, useEffect } from 'react';
import { Typography } from "views/utilities/MyCustomFile";
import CreatableSelect from 'react-select/creatable';
import { getAPI } from "../axios/api";

const CreatableTypeCommon = ({ formik, name, label, APIURL, status }) => {
    const handleChange = (option) => formik.setFieldValue(name, option ? option.value : "");
    const handleBlur = () => formik.setFieldTouched(name, true);

    const [state, setState] = useState([])
    const fetchTypes = async () => {
        try {
            const { status, message } = await getAPI(APIURL);
            setState(status ? message : [])
        } catch (error) { setState([]) }
    }

    useEffect(() => {
        fetchTypes()
    }, [])

    return (
        <div style={{ marginTop: 9 }}>
            <CreatableSelect
                styles={{
                    menu: (provided) => ({
                        ...provided,
                        zIndex: 1300, // Set a high z-index to ensure it overlays other elements
                    }),
                    placeholder: (provided) => ({
                        ...provided,
                        color: formik.touched[name] && formik.errors[name] ? "red" : "", // Red if error exists, gray otherwise
                    }),
                    control: (provided, state) => ({
                        ...provided,
                        borderColor: formik.touched[name] && formik.errors[name] ? "red" : state.isFocused ? "blue" : "gray", // Red if error, blue if focused, gray otherwise
                    })
                }}
                isClearable
                name={name}
                options={state || []}
                value={formik.values[name] ? { label: formik.values[name], value: formik.values[name] } : null}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder={`${label}${status ? "*" : ""}`}
            />
            {formik.touched[name] && formik.errors[name] && (
                <Typography variant="body2" style={{ color: "red", fontSize: 10, marginLeft: 0 }}>
                    {formik.errors[name]}
                </Typography>
            )}
        </div>
    );
};

export default CreatableTypeCommon;